module.exports = __webpack_public_path__ + "static/media/03_hero_desktop.b3396928.jpg";